import Vue from 'vue';
import Vuex from 'vuex';
import AuthManager from '@/auth/authManager';
import managerConfig from '@/auth/config';
import userBehavior from './userBehavior';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    userBehavior,
  },
  state: {
    // @param {Number} timeId token自動刷新產生的timeoutId default為-1
    timeoutId: -1,
    // @param {Object} manager oidc的管理
    manager: {},
    userInfo: {},
  },
  getters: {
    // 取得manager
    getManager(state) {
      return state.manager;
    },
    // 取得token
    getTokens(state) {
      return state.tokens;
    },
    getUserInfo(state) {
      return state.userInfo;
    },
  },
  mutations: {
    // 設定timeoutId
    SET_TIMEOUT_ID(state, timeoutId) {
      state.timeoutId = timeoutId;
    },
    // init oidc-manager
    INITIAL_OIDC(state, manager) {
      state.manager = manager;
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    // 更新token
    UPDATE_TOKEN(state, tokens) {
      state.tokens = tokens;
    },
    // 停止之前的刷新token的循環
    STOP_BEFORE_TIMEOUT(state) {
      clearTimeout(state.timeoutId);
    },
  },
  actions: {
    // 停止之前的刷新token的循環
    stopBeforeTimeout({ commit }) {
      commit('STOP_BEFORE_TIMEOUT');
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USERINFO', userInfo);
    },
    // 登入後授權回來換使用者的token
    loginRedirectCallback({ getters }) {
      return getters.getManager.signinRedirectCallback();
    },
    // 清除不完整授權的請求
    clearIncompleteAuthorize({ getters }) {
      getters.getManager.clearStaleState();
    },
    // 初始化 Oidc 實體（router 守衛與 App.vue 都會呼叫，只初始化一次）
    initialOidc({ state, dispatch, commit }) {
      if (state.manager.getUser) return;
      const authManager = new AuthManager();
      authManager.initManager(managerConfig);
      // 停止之前的刷新token，轉導至登入頁重新登入
      const renewTokensErrorCallback = () => {
        commit('STOP_BEFORE_TIMEOUT');
        dispatch('loginRedirectUnityPage');
      };
      const renewTokens = (userRenewTokens) => { dispatch('updateToken', userRenewTokens); };
      // eslint-disable-next-line no-underscore-dangle
      authManager.setOidcManagerEvents(this._vm, renewTokensErrorCallback, renewTokens);
      commit('INITIAL_OIDC', authManager.manager);
    },
    // 從 oidc-client 取回已登入的使用者並更新 tokens，過期則先嘗試刷新
    async restoreUser({ getters, dispatch }) {
      const manager = getters.getManager;
      let user = await manager.getUser();
      if (user && user.expired) {
        user = await manager.signinSilent().catch(() => null);
      }
      if (!user) return false;
      dispatch('updateToken', {
        at: user.access_token,
        idt: user.id_token,
        rt: user.refresh_token,
      });
      return true;
    },
    // 確認IDP是否為登入狀態
    async checkIDPIsLogin({ getters }) {
      const manager = getters.getManager;
      return manager.signinSilent();
    },
    // 設定timeoutId
    setTimeoutId({ commit }, timeoutId) {
      commit('SET_TIMEOUT_ID', timeoutId);
    },
    // 登入轉導至統一登入頁面
    loginRedirectUnityPage({ getters }) {
    // 先刪除使用者紀錄，防止有重複使用者紀錄的可能
      getters.getManager.removeUser();
      getters.getManager.signinRedirect({ prompt: 'select_account' });
    },

    // 登出轉導至統一登出頁面
    logoutRedirectUnityPage({ getters }) {
      getters.getManager.signoutRedirect();
    },
    idpRefreshCallback({ getters }) {
      getters.getManager.signinSilentCallback();
    },
    // 確認OIDC是否有取得用戶資訊
    getUserInfo({ getters }) {
      return getters.getManager.getUser().then((user) => user);
    },
    updateToken({ commit }, tokens) {
      commit('UPDATE_TOKEN', tokens);
    },
  },
});
